/* eslint-disable react-hooks/exhaustive-deps */
import {
    buildDateFacet,
    buildDateRange,
    DateFacet as DateFacetHeadless, DateFilter,
} from "@coveo/headless";
import $, {datepicker} from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import React, {FunctionComponent, useEffect, useRef, useState} from "react";
import {useDispatch} from 'react-redux';
import {setActiveActionSearchBox} from "../../../../actions/searchBoxAction";
import {headlessEngine} from "../../../../engine/engine";
import '../scss/Facet-Accordion.scss';
import {facetDate} from "../../../../controllers/facetControllers";
import {
    DateFacetValue
} from "@coveo/headless/dist/definitions/features/facets/range-facets/date-facet-set/interfaces/response";

interface IFacetProps {
    title: string;
    field: string;
    facetDeSelect?: any;
    pillProSelected?: any;
    pillConsumerSelected?: any;
    pillBusinessSelected?: any;
}

interface IRangeDateFacetProps extends IFacetProps {
    delimiter?: string;

    startDateController: DateFilter;

    endDateController: DateFilter;
}

export const DateFacet2: FunctionComponent<IRangeDateFacetProps> = (props) => {
    // const [filled, setFilled] = useState(false);
    // const [filledStartDate, setFilledStartDate] = useState(false);
    // const [filledEndDate, setFilledEndDate] = useState(false);
    const dispatch = useDispatch();
    // let startDateFacet: DateFacetHeadless;
    // let endDateFacet: DateFacetHeadless;
    // let reffStartDate = useRef(props.controller);
    // let reffEndDate = useRef(props.controller);
    // const [inputStartDate, setInputStartDate] = useState(props.controller);
    // const [inputEndDate, setInputEndDate] = useState(props.controller);
    const today = new Date();

    const {startDateController, endDateController} = props;
    const [state, setState] = useState({
        "startDateControllerState": startDateController.state,
        "endDateControllerState": endDateController.state,
    });
    let startRef: HTMLInputElement;
    let endRef: HTMLInputElement;

    useEffect(() => startDateController.subscribe(() => setState({
        ...state,
        "startDateControllerState": startDateController.state
    })), []);

    useEffect(() => endDateController.subscribe(() => setState({
        ...state,
        "endDateControllerState": endDateController.state
    })), []);

    const submitFilter = () => {
        console.log("submitFilter")
        const startDateEle = document.getElementById("startDate") as HTMLInputElement;
        const endDateEle = document.getElementById("endDate") as HTMLInputElement;

        let startDateVal = startDateEle.value;
        let endDateVal = endDateEle.value;

        if (!startDateVal || !endDateVal) {
            return
        }
        dispatch(setActiveActionSearchBox(false));
        const [startDate, endDate] = formatInputDate(startDateVal, endDateVal);

        startDateEle.value = startDate.toLocaleDateString("en-US");
        endDateEle.value = endDate.toLocaleDateString("en-US");
        console.log("setRange")

        startDateController.setRange(
            buildDateRange({
                start: new Date(Date.parse(startDateVal)),
                end: new Date(Date.parse(endDateVal)),
            })
        );

        endDateController.setRange(
            buildDateRange({
                start: new Date(Date.parse(startDateVal)),
                end: new Date(Date.parse(endDateVal)),
            })
        );
    }

    function padTo2Digits(num: any) {
        return num.toString().padStart(2, '0');
    }

    function formatDate(date: any) {
        return (
            [
                date.getFullYear(),
                padTo2Digits(date.getMonth() + 1),
                padTo2Digits(date.getDate()),
            ].join('/')
            // + '@' +
            // [
            //   padTo2Digits(date.getHours()),
            //   padTo2Digits(date.getMinutes()),
            //   padTo2Digits(date.getSeconds()),
            // ].join(':')
        );
    }

    const formatInputDate = (startDateVal: string, endDateVal: string) => {
        let startDateParse = Date.parse(startDateVal);
        let endDateParse = Date.parse(endDateVal);

        if (!startDateParse) {
            startDateParse = Date.parse(today.toString());
        }

        if (!endDateParse) {
            endDateParse = Date.parse(today.toString());
        }

        if (startDateParse > endDateParse) {
            //reverse startDate & endDate val
            var temp = startDateParse;
            startDateParse = endDateParse;
            endDateParse = temp;
        }

        if ((new Date(startDateParse)).toLocaleDateString("en-US") === (new Date(endDateParse)).toLocaleDateString("en-US")) {
            endDateParse += 86400000;
        }

        const startDate = new Date(startDateParse);
        const endDate = new Date(endDateParse);
        // startDateEle.value = startDate.toLocaleDateString("en-US");
        // endDateEle.value = endDate.toLocaleDateString("en-US");
        // const formatDateStart = formatDate(startDate);
        // const formatDateEnd = formatDate(endDate);

        return [startDate, endDate];
    }

    // useEffect(() => {
    //     console.log("useEffect.filled 1")
    //     const startDateEle = document.getElementById("startDate") as HTMLInputElement;
    //     const endDateEle = document.getElementById("endDate") as HTMLInputElement;
    //
    //     let startDateVal = startDateEle.value;
    //     let endDateVal = endDateEle.value;
    //
    //     if (!startDateVal || !endDateVal) {
    //         if (!startDateVal) setFilledStartDate(false);
    //         if (!endDateVal) setFilledEndDate(false);
    //         return;
    //     }
    //
    //     const [startDate, endDate] = formatInputDate(startDateVal, endDateVal);
    //     dispatch(setActiveActionSearchBox(false));
    //     if (filledStartDate) {
    //         startDateEle.value = startDate.toLocaleDateString("en-US");
    //
    //         startDateFacet = buildDateFacet(headlessEngine, {
    //             options: {
    //                 field: 'aem_startdate',
    //                 generateAutomaticRanges: false,
    //                 currentValues: [
    //                     buildDateRange({
    //                         start: formatDate(startDate),
    //                         end: formatDate(endDate),
    //                         dateFormat: 'YYYY/MM/DD'
    //                     }),
    //                 ]
    //             }
    //         });
    //
    //         startDateFacet.deselectAll();
    //         setInputStartDate(startDateFacet);
    //     }
    //
    //     if (filledEndDate) {
    //         endDateEle.value = endDate.toLocaleDateString("en-US");
    //
    //         endDateFacet = buildDateFacet(headlessEngine, {
    //             options: {
    //                 field: 'aem_enddate',
    //                 generateAutomaticRanges: false,
    //                 currentValues: [
    //                     buildDateRange({
    //                         start: formatDate(startDate),
    //                         end: formatDate(endDate),
    //                         dateFormat: 'YYYY/MM/DD'
    //                     }),
    //                 ]
    //             }
    //         });
    //
    //         endDateFacet.deselectAll();
    //         setInputEndDate(endDateFacet);
    //
    //         // startDateFacet.toggleSingleSelect(inputStartDate.state.values[0])
    //         // endDateFacet.toggleSingleSelect(inputEndDate.state.values[0])
    //         // setTimeout(() => {
    //         //   refff.current.deselectAll();
    //         //   refff.current = startDateFacet;
    //         //   refff.current.toggleSingleSelect(startDateFacet.state.values[0]);
    //         //   refff.current.deselectAll();
    //         //   refff.current = endDateFacet;
    //         //   refff.current.toggleSingleSelect(endDateFacet.state.values[0]);
    //         // }, 2000);
    //         // clear all facet pill seleceted
    //         // props.facetDeSelect.facetPills.toggleSelect(props.pillConsumerSelected);
    //     }
    // }, [filledStartDate, filledEndDate])

    // useEffect(() => {
    //     console.log("Q1")
    //     console.log(inputStartDate)
    //     console.log(inputEndDate)
    //     console.log(props.controller)
    //     console.log(reffStartDate.current)
    //     console.log(reffEndDate.current)
    //     console.log(inputEndDate !== props.controller && inputStartDate !== props.controller)
    //     console.log(reffStartDate.current !== props.controller && reffEndDate.current !== props.controller)
    //     console.log(inputStartDate.state)
    //     console.log(inputEndDate.state)
    //     console.log("--")
    //     console.log(inputEndDate.state.values[0] && inputStartDate.state.values[0])
    //     console.log("--")
    //     if (inputEndDate !== props.controller && inputStartDate !== props.controller) {
    //         console.log("Q2")
    //         //Deselect all from Price range old and check condition if refff is controller -> no deselecall
    //         if (reffStartDate.current !== props.controller && reffEndDate.current !== props.controller) {
    //             console.log("Q3")
    //             reffStartDate.current.deselectAll();
    //             reffEndDate.current.deselectAll();
    //         }
    //         //Assignment pricerange when effect for next render
    //         reffStartDate.current = inputStartDate;
    //         reffEndDate.current = inputEndDate;
    //         if (inputEndDate.state.values[0] && inputStartDate.state.values[0]) {
    //             console.log("Q4")
    //             // first one deselect all facet price after create or selected
    //             inputStartDate.toggleSingleSelect(inputStartDate.state.values[0]);
    //             inputEndDate.toggleSingleSelect(inputEndDate.state.values[0]);
    //         }
    //         setFilled(false);
    //     }
    // }, [inputEndDate
    //     , inputStartDate
    //     , inputEndDate === props.controller ? undefined : inputEndDate.state.values.length
    //     , inputStartDate === props.controller ? undefined : inputStartDate.state.values.length])

    // useEffect(() => {
    //
    // }, [inputEndDate,]);


    $('#startDate').datepicker({
        constrainInput: false,
        showOtherMonths: true,
        changeMonth: true,
        changeYear: true,
        yearRange: "-100:+100",
        monthNamesShort: ["January", "February", "March",
            "April", "May", "June", "July", "August",
            "September", "October", "November", "December"],
        onSelect: function () {
            $('.datepicker').datepicker('hide');
            submitFilter();
        },
    });

    $('#endDate').datepicker({
        constrainInput: false,
        showOtherMonths: true,
        changeMonth: true,
        changeYear: true,
        yearRange: "-100:+100",
        monthNamesShort: ["January", "February", "March",
            "April", "May", "June", "July", "August",
            "September", "October", "November", "December"],
        onSelect: function () {
            $('.datepicker').datepicker('hide');
            submitFilter();
        },
    });

    function expandCollapseAccordion(e: any) {
        var accordion = e.target;
        var children = e.target.nextElementSibling;
        if (!accordion.classList.contains("collapsed")) {
            accordion.classList.add("collapsed");
            children.classList.add("deactive");
        } else {
            accordion.classList.remove("collapsed");
            children.classList.remove("deactive");
        }
    }
    let isMobileView = window.innerWidth < 768;
    function getDateFacetSelected () : void | string  {
        const startDateEle = document.getElementById("startDate") as HTMLInputElement;
        const endDateEle = document.getElementById("endDate") as HTMLInputElement;

        let startDateVal = startDateEle?.value;
        let endDateVal = endDateEle?.value;
        if (startDateVal && endDateVal) {
            return `${startDateVal} - ${endDateVal}`
        }
    }

    return (
        <div className="facet-type-item">
            <div className="facet-accordion-container">
                <div className="facet-accordion">
                    <button className={"facet-type" + (isMobileView ? " collapsed":"")} onClick={(e) => expandCollapseAccordion(e)}>{props.title}</button>
                    <div className={"facet-accordion-children date-children clearfix" + (isMobileView ? " deactive":"")}>
                        <div className="startdate-section">
                            <div className="calendar-icon"></div>
                            <input
                                onKeyDown={(e) => e.key === "Enter" && submitFilter()}
                                ref={(ref) => (startRef = ref!)}
                                data-format-type="mm/dd/yyyy"
                                type="text" className="datepicker form-control" id="startDate"
                                placeholder="MM/DD/YYYY" autoComplete="off"/>
                        </div>
                        <p>TO</p>
                        <div className="enddate-section">
                            <div className="calendar-icon"></div>
                            <input
                                onKeyDown={(e) => e.key === "Enter" && submitFilter()}
                                ref={(ref) => (endRef = ref!)}
                                data-format-type="mm/dd/yyyy"
                                type="text" className="datepicker form-control" id="endDate" placeholder="MM/DD/YYYY"
                                autoComplete="off"/>
                        </div>
                    </div>
                    <div className="facet-value-selected">{getDateFacetSelected()}</div>
                </div>
            </div>
        </div>
    );
};
